import { render, staticRenderFns } from "./AutocompleteHeadTeacherCard.vue?vue&type=template&id=e0e0cd1a&"
import script from "./AutocompleteHeadTeacherCard.vue?vue&type=script&lang=js&"
export * from "./AutocompleteHeadTeacherCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent})
